import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of } from 'rxjs';
import { MailService } from '../../services/mail.service';
import * as MailActions from './mail.action';
import swal from 'sweetalert2';
@Injectable()
export class MailEffect {
  constructor(
    private actions$: Actions,

    private mailService: MailService,
    private store: Store
  ) {}

  loadMailMemberTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MailActions.GetMailMemberTemplates),
      mergeMap((model) => {
        return this.mailService.getMailMemberTemplates(model.memberIds).pipe(
          map((model) => {
            return MailActions.GetMailMemberTemplatesSuccess({ model });
          }),
          catchError((err) => {
            return of(MailActions.GetMailMemberTemplatesFailure(err));
          })
        );
      })
    )
  );

  loadSentMailLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MailActions.loadSentMailLogs),
      mergeMap((model) => {
        return this.mailService.getSentMailLog(model.sentMailLogId).pipe(
          map((model) => {
            return MailActions.loadSentMailLogsSuccess({ sentMailLogs: model });
          }),
          catchError((err) => {
            return of(MailActions.loadSentMailLogsFailure({ err: err }));
          })
        );
      })
    )
  );

  loadMailTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MailActions.GetMailTemplate),
      mergeMap((model) => {
        return this.mailService.getMailTemplate(model.id).pipe(
          map((model) => {
            return MailActions.GetMailTemplateSuccess({ model });
          }),
          catchError((err) => {
            return of(MailActions.GetMailTemplateFailure(err));
          })
        );
      })
    )
  );

  loadCommunicationLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MailActions.GetCommunicationLogs),
      mergeMap(({ log }) => { // Destructure params from the action
        return this.mailService.getCommunincationLogs(log).pipe(
          map((model) => MailActions.GetCommunicationLogsSuccess({ model })),
          catchError((err) => of(MailActions.GetCommunicationLogsFailure({ err })))
        );
      })
    )
  );

  saveMailTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MailActions.SaveMailTemplate),
      mergeMap((model) => {
        return this.mailService.saveMailTemplate(model.model).pipe(
          map((response) => {
            return MailActions.SaveMailTemplateSuccess({ response });
          }),
          catchError((err) => {
            return of(MailActions.SaveMailTemplateFailure(err));
          })
        );
      })
    )
  );

  previewMail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MailActions.PreviewMail),
      mergeMap((model) => {
        return this.mailService.previewMail(model.model).pipe(
          map((response) => {
            return MailActions.PreviewMailSuccess({ response });
          }),
          catchError((err) => {
            return of(MailActions.PreviewMailFailure(err));
          })
        );
      })
    )
  );

  saveReplyToEmailAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MailActions.SaveReplyToEMailAddress),
      mergeMap((model) => {
        return this.mailService
          .saveReplyToEmailAddress(model.emailAddress)
          .pipe(
            map((response) => {
              return MailActions.SaveReplyToEMailAddresssSuccess({response});
            }),
            catchError((err) => {
              return of(MailActions.SaveReplyToEMailAddressFailure({ err: err }));
            })
          );
      })
    )
  );
}
